// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ASVl","footer":"Form_footer__1tT-J"};